import React from "react";
import { styled } from "@mui/material/styles";
import { IoMdMale, IoMdFemale } from "react-icons/io";
import * as MuiMaterial from "@mui/material";
import { renderToStaticMarkup } from "react-dom/server";
import { DARK_BLUE, PRIMARY_BLUE } from "../../enums/Colors";

const convertSvg = (svg) => {
  const markup = renderToStaticMarkup(svg);
  const encoded = encodeURIComponent(markup);
  const dataUri = `url('data:image/svg+xml;utf8,${encoded}')`;
  return dataUri;
};

export const GenderPicker = styled(MuiMaterial.Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  marginRight: 10,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        borderRadius: 20 / 1,
        backgroundColor: "#f8b9d4",
        backgroundImage: convertSvg(<IoMdFemale color="#000000" />),
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        ...theme.applyStyles("dark", {
          backgroundColor: "hotpink",
        }),
        ...theme.applyStyles("light", {
          backgroundColor: "hotpink",
        }),
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#001e3f",
    width: 32,
    height: 32,
    "&::before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: convertSvg(<IoMdMale color="#fff" />),
    },
    ...theme.applyStyles(
      "dark",
      {
        backgroundColor: PRIMARY_BLUE,
      },
      "light",
      {
        backgroundColor: DARK_BLUE,
      }
    ),
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: "#aab4be",
    borderRadius: 20 / 2,
    ...theme.applyStyles("dark", {
      backgroundColor: "#8796A5",
    }),
  },
}));
